"use strict";

exports.__esModule = true;
var _PredefinedCommentsRoutes = require("./PredefinedCommentsRoutes");
Object.keys(_PredefinedCommentsRoutes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PredefinedCommentsRoutes[key]) return;
  exports[key] = _PredefinedCommentsRoutes[key];
});